import * as actions from './my-profile-actions';
import * as mutations from './my-profile-mutations';
import { state } from './my-profile-state';

export const myProfile = {
  state,
  mutations,
  actions,
};
